import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://fzmxipzyugrwflqnthnh.supabase.co'
const SUPABASE_ANON_KEY = 'sb_publishable_0orSj--U0JaD9B4Uez2l4w_e0UvDM8m'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)

export const signUp = (email, password, name) =>
  supabase.auth.signUp({ email, password, options: { data: { name } } })

export const signIn = (email, password) =>
  supabase.auth.signInWithPassword({ email, password })

export const signOut = () => supabase.auth.signOut()

export const getUser = () => supabase.auth.getUser()

export const createHousehold = async (name, userId) => {
  const code = Math.random().toString(36).substring(2, 8).toUpperCase()
  const { data, error } = await supabase
    .from('households')
    .insert({ name, invite_code: code, created_by: userId })
    .select()
    .single()
  if (error) throw error
  await supabase.from('household_members').insert({ household_id: data.id, user_id: userId, role: 'admin' })
  return data
}

export const joinHousehold = async (code, userId) => {
  const { data: hh, error } = await supabase
    .from('households')
    .select()
    .eq('invite_code', code.toUpperCase())
    .single()
  if (error) throw new Error('Invalid invite code')
  await supabase.from('household_members').insert({ household_id: hh.id, user_id: userId, role: 'member' })
  return hh
}

export const getUserHousehold = async (userId) => {
  const { data } = await supabase
    .from('household_members')
    .select('households(*)')
    .eq('user_id', userId)
    .single()
  return data?.households || null
}

export const addExpense = async ({ amount, category, mode, note, date, userId, householdId }) => {
  const { data, error } = await supabase.from('expenses').insert({
    amount,
    category,
    mode,
    note,
    date,
    user_id: userId,
    household_id: householdId || null
  }).select().single()
  if (error) throw error
  return data
}

export const getExpenses = async ({ userId, householdId, month, year }) => {
  const start = `${year}-${String(month).padStart(2, '0')}-01`
  const end = `${year}-${String(month + 1).padStart(2, '0')}-01`
  let query = supabase.from('expenses').select('*')
    .gte('date', start).lt('date', end)
    .order('date', { ascending: false })

  if (householdId) {
    query = query.eq('household_id', householdId)
  } else {
    query = query.eq('user_id', userId).is('household_id', null)
  }
  const { data, error } = await query
  if (error) throw error
  return data || []
}

export const deleteExpense = async (id) => {
  const { error } = await supabase.from('expenses').delete().eq('id', id)
  if (error) throw error
}

export const saveBudgets = async (budgets, userId, householdId) => {
  const rows = Object.entries(budgets).map(([category, amount]) => ({
    category, amount, user_id: userId, household_id: householdId || null
  }))
  await supabase.from('budgets').delete()
    .eq('user_id', userId)
    .is('household_id', null)
  if (rows.length) {
    const { error } = await supabase.from('budgets').insert(rows)
    if (error) throw error
  }
}

export const getBudgets = async (userId, householdId) => {
  const { data } = await supabase.from('budgets').select()
    .eq('user_id', userId)
    .is('household_id', null)
  const map = {}
  ;(data || []).forEach(b => { map[b.category] = b.amount })
  return map
}

// ── CUSTOM CATEGORIES ─────────────────────────────────────────────────────────
export const getCustomCategories = async (userId) => {
  const { data } = await supabase.from('custom_categories').select().eq('user_id', userId)
  return data || []
}

export const addCustomCategory = async (userId, label, icon, color) => {
  const { data, error } = await supabase.from('custom_categories')
    .insert({ user_id: userId, label, icon, color }).select().single()
  if (error) throw error
  return data
}

export const deleteCustomCategory = async (id) => {
  const { error } = await supabase.from('custom_categories').delete().eq('id', id)
  if (error) throw error
}

// ── CUSTOM PAYMENT MODES ──────────────────────────────────────────────────────
export const getCustomModes = async (userId) => {
  const { data } = await supabase.from('custom_modes').select().eq('user_id', userId)
  return data || []
}

export const addCustomMode = async (userId, label, icon) => {
  const { data, error } = await supabase.from('custom_modes')
    .insert({ user_id: userId, label, icon }).select().single()
  if (error) throw error
  return data
}

export const deleteCustomMode = async (id) => {
  const { error } = await supabase.from('custom_modes').delete().eq('id', id)
  if (error) throw error
}
